// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { CalculatorIcon as CalculatorGlyph } from "@phosphor-icons/react/dist/ssr/Calculator";
import { CalendarBlankIcon as CalendarBlankGlyph } from "@phosphor-icons/react/dist/ssr/CalendarBlank";
import { CalendarCheckIcon as CalendarCheckGlyph } from "@phosphor-icons/react/dist/ssr/CalendarCheck";
import { CalendarDotsIcon as CalendarDotsGlyph } from "@phosphor-icons/react/dist/ssr/CalendarDots";
import { CalendarPlusIcon as CalendarPlusGlyph } from "@phosphor-icons/react/dist/ssr/CalendarPlus";
import { CameraIcon as CameraGlyph } from "@phosphor-icons/react/dist/ssr/Camera";
import { CarIcon as CarGlyph } from "@phosphor-icons/react/dist/ssr/Car";
import { CaretDoubleDownIcon as CaretDoubleDownGlyph } from "@phosphor-icons/react/dist/ssr/CaretDoubleDown";
import { CaretDoubleLeftIcon as CaretDoubleLeftGlyph } from "@phosphor-icons/react/dist/ssr/CaretDoubleLeft";
import { CaretDoubleRightIcon as CaretDoubleRightGlyph } from "@phosphor-icons/react/dist/ssr/CaretDoubleRight";
import { CaretDoubleUpIcon as CaretDoubleUpGlyph } from "@phosphor-icons/react/dist/ssr/CaretDoubleUp";
import { CaretDownIcon as CaretDownGlyph } from "@phosphor-icons/react/dist/ssr/CaretDown";
import { CaretLeftIcon as CaretLeftGlyph } from "@phosphor-icons/react/dist/ssr/CaretLeft";
import { CaretRightIcon as CaretRightGlyph } from "@phosphor-icons/react/dist/ssr/CaretRight";
import { CaretUpIcon as CaretUpGlyph } from "@phosphor-icons/react/dist/ssr/CaretUp";
import { CaretUpDownIcon as CaretUpDownGlyph } from "@phosphor-icons/react/dist/ssr/CaretUpDown";
import { ChartBarIcon as ChartBarGlyph } from "@phosphor-icons/react/dist/ssr/ChartBar";
import { ChartLineIcon as ChartLineGlyph } from "@phosphor-icons/react/dist/ssr/ChartLine";
import { ChartLineUpIcon as ChartLineUpGlyph } from "@phosphor-icons/react/dist/ssr/ChartLineUp";
import { ChatCircleIcon as ChatCircleGlyph } from "@phosphor-icons/react/dist/ssr/ChatCircle";
import { ChatCircleDotsIcon as ChatCircleDotsGlyph } from "@phosphor-icons/react/dist/ssr/ChatCircleDots";
import { ChatsCircleIcon as ChatsCircleGlyph } from "@phosphor-icons/react/dist/ssr/ChatsCircle";
import { CheckIcon as CheckGlyph } from "@phosphor-icons/react/dist/ssr/Check";
import { CheckCircleIcon as CheckCircleGlyph } from "@phosphor-icons/react/dist/ssr/CheckCircle";
import { CheckSquareIcon as CheckSquareGlyph } from "@phosphor-icons/react/dist/ssr/CheckSquare";
import { ChecksIcon as ChecksGlyph } from "@phosphor-icons/react/dist/ssr/Checks";
import { CircleIcon as CircleGlyph } from "@phosphor-icons/react/dist/ssr/Circle";
import { CircleDashedIcon as CircleDashedGlyph } from "@phosphor-icons/react/dist/ssr/CircleDashed";
import { CircleNotchIcon as CircleNotchGlyph } from "@phosphor-icons/react/dist/ssr/CircleNotch";
import { ClipboardIcon as ClipboardGlyph } from "@phosphor-icons/react/dist/ssr/Clipboard";
import { ClipboardTextIcon as ClipboardTextGlyph } from "@phosphor-icons/react/dist/ssr/ClipboardText";
import { ClockIcon as ClockGlyph } from "@phosphor-icons/react/dist/ssr/Clock";
import { CloudArrowUpIcon as CloudArrowUpGlyph } from "@phosphor-icons/react/dist/ssr/CloudArrowUp";
import { CoffeeIcon as CoffeeGlyph } from "@phosphor-icons/react/dist/ssr/Coffee";
import { CoinsIcon as CoinsGlyph } from "@phosphor-icons/react/dist/ssr/Coins";

export const Calculator = /* @__PURE__ */ createAppIcon(
  CalculatorGlyph,
  "Calculator",
);
export const CalendarBlank = /* @__PURE__ */ createAppIcon(
  CalendarBlankGlyph,
  "CalendarBlank",
);
export const CalendarCheck = /* @__PURE__ */ createAppIcon(
  CalendarCheckGlyph,
  "CalendarCheck",
);
export const CalendarDots = /* @__PURE__ */ createAppIcon(
  CalendarDotsGlyph,
  "CalendarDots",
);
export const CalendarPlus = /* @__PURE__ */ createAppIcon(
  CalendarPlusGlyph,
  "CalendarPlus",
);
export const Camera = /* @__PURE__ */ createAppIcon(CameraGlyph, "Camera");
export const Car = /* @__PURE__ */ createAppIcon(CarGlyph, "Car");
export const CaretDoubleDown = /* @__PURE__ */ createAppIcon(
  CaretDoubleDownGlyph,
  "CaretDoubleDown",
);
export const CaretDoubleLeft = /* @__PURE__ */ createAppIcon(
  CaretDoubleLeftGlyph,
  "CaretDoubleLeft",
);
export const CaretDoubleRight = /* @__PURE__ */ createAppIcon(
  CaretDoubleRightGlyph,
  "CaretDoubleRight",
);
export const CaretDoubleUp = /* @__PURE__ */ createAppIcon(
  CaretDoubleUpGlyph,
  "CaretDoubleUp",
);
export const CaretDown = /* @__PURE__ */ createAppIcon(
  CaretDownGlyph,
  "CaretDown",
);
export const CaretLeft = /* @__PURE__ */ createAppIcon(
  CaretLeftGlyph,
  "CaretLeft",
);
export const CaretRight = /* @__PURE__ */ createAppIcon(
  CaretRightGlyph,
  "CaretRight",
);
export const CaretUp = /* @__PURE__ */ createAppIcon(CaretUpGlyph, "CaretUp");
export const CaretUpDown = /* @__PURE__ */ createAppIcon(
  CaretUpDownGlyph,
  "CaretUpDown",
);
export const ChartBar = /* @__PURE__ */ createAppIcon(
  ChartBarGlyph,
  "ChartBar",
);
export const ChartLine = /* @__PURE__ */ createAppIcon(
  ChartLineGlyph,
  "ChartLine",
);
export const ChartLineUp = /* @__PURE__ */ createAppIcon(
  ChartLineUpGlyph,
  "ChartLineUp",
);
export const ChatCircle = /* @__PURE__ */ createAppIcon(
  ChatCircleGlyph,
  "ChatCircle",
);
export const ChatCircleDots = /* @__PURE__ */ createAppIcon(
  ChatCircleDotsGlyph,
  "ChatCircleDots",
);
export const ChatsCircle = /* @__PURE__ */ createAppIcon(
  ChatsCircleGlyph,
  "ChatsCircle",
);
export const Check = /* @__PURE__ */ createAppIcon(CheckGlyph, "Check");
export const CheckCircle = /* @__PURE__ */ createAppIcon(
  CheckCircleGlyph,
  "CheckCircle",
);
export const CheckSquare = /* @__PURE__ */ createAppIcon(
  CheckSquareGlyph,
  "CheckSquare",
);
export const Checks = /* @__PURE__ */ createAppIcon(ChecksGlyph, "Checks");
export const Circle = /* @__PURE__ */ createAppIcon(CircleGlyph, "Circle");
export const CircleDashed = /* @__PURE__ */ createAppIcon(
  CircleDashedGlyph,
  "CircleDashed",
);
export const CircleNotch = /* @__PURE__ */ createAppIcon(
  CircleNotchGlyph,
  "CircleNotch",
);
export const Clipboard = /* @__PURE__ */ createAppIcon(
  ClipboardGlyph,
  "Clipboard",
);
export const ClipboardText = /* @__PURE__ */ createAppIcon(
  ClipboardTextGlyph,
  "ClipboardText",
);
export const Clock = /* @__PURE__ */ createAppIcon(ClockGlyph, "Clock");
export const CloudArrowUp = /* @__PURE__ */ createAppIcon(
  CloudArrowUpGlyph,
  "CloudArrowUp",
);
export const Coffee = /* @__PURE__ */ createAppIcon(CoffeeGlyph, "Coffee");
export const Coins = /* @__PURE__ */ createAppIcon(CoinsGlyph, "Coins");
